import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteCaveatTypeActions } from "store/ducks/settings/caveat-types";

export function* deleteCaveatTypeRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/indent-caveat-types/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteCaveatTypeActions.success(data));
    notify("success", "Tipo de ressalva deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteCaveatTypeActions.failure(errorMessage));
  }
}
